export const PermissionsActionType = Object.freeze({
    SET_EDIT_PERMISSION: 'Authorization:: Edit permission data',
    SET_EXISTING_PERMISSIONS: 'Permissions:: Set existing permissions',
    SET_PERMISSIONS: 'Permissions:: Set all permissions data',
    SET_TAB: 'PermissionPanel:: Set Tab',
    SET_BREAK_DOWN: 'PermissionPanel:: Set breakdown',
    CLOSE_EDIT_DIALOG: 'Permissions:: Close edit permission dialog box',
    OPEN_EDIT_DIALOG: 'Permissions:: Open edit permission dialog box',
    CLOSE_CREATE_DIALOG: 'Permissions:: Close create permission dialog box',
    OPEN_CREATE_DIALOG: 'Permissions:: Open create permission dialog box',
    SET_INVITE_TYPE: 'Permissions:: On set type of the invite dialog',
    SET_INVITE_LINK: 'Permissions:: Set Invite link',
    SET_ORDER_BY: 'Permission Table:: Set Order by field',
    SET_PAGING_OPT: 'Permission Table:: Set Pagination options',
    SET_FILTER: 'Permission Table:: Set Filter',
    SET_SEARCH_TEXT: 'Permission Table :: Set Search Text',
    SET_PAGE_OFFSET:
        'Permission Table :: Set Offset of the permission table query',
    SET_CONFIRMATION_DIALOG: 'Permission Table:: Delete confirmation Dialog',
    SET_CREATE_PERMISSION:
        'Create Permission Dialog:: Create permission data set',
})

export const PERMISSION_PROP = Object.freeze({
    ID: 'id',
    NAME: 'name',
    CODENAME: 'codename',
    CREATE_DATE: 'create_date',
    UPDATE_DATE: 'update_date',
})

export const UILabels = {
    [PERMISSION_PROP.NAME]: 'Name',
    [PERMISSION_PROP.CODENAME]: 'Codename',
    [PERMISSION_PROP.CREATE_DATE]: 'Created On',
    [PERMISSION_PROP.UPDATE_DATE]: 'Updated On',
}

export const PERMISSION_COLUMNS_ENHANCED = Object.freeze([
    {
        id: PERMISSION_PROP.NAME,
        label: UILabels[PERMISSION_PROP.NAME],
        numeric: false,
        disablePadding: false,
    },
    {
        id: PERMISSION_PROP.CODENAME,
        label: UILabels[PERMISSION_PROP.CODENAME],
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
    {
        id: PERMISSION_PROP.CREATE_DATE,
        label: UILabels[PERMISSION_PROP.CREATE_DATE],
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
    {
        id: PERMISSION_PROP.UPDATE_DATE,
        label: UILabels[PERMISSION_PROP.UPDATE_DATE],
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
])

export const ITEM_HEIGHT = 48
export const ITEM_PADDING_TOP = 8
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}
